//libs
import React, {useEffect, useState} from "react";

//styling
import "./QuestionDate.scss";



function QuestionDate({ data }) {

  return (
    <div className="question-date">
      Date
    </div>
  );
}

export default QuestionDate;